import moment from 'moment';
import { PluginConnection } from '../../../domain/metrics';
import { Asset } from '../../../domain/assets';
import { ReportEntity } from './reportEntity';

export function getReportName(item: { report: ReportEntity; asset: Asset }) {
    return [item.asset.name, moment(item.report.createdAt).format('YYYY/MM/DD')].join(
        ' - '
    );
}

export function getReportStatus(item: {
    report: ReportEntity;
    connections: PluginConnection[];
}) {
    return item.connections.some((item) => item.status === 'syncing')
        ? 'syncing'
        : 'ready';
}
